const firebaseConfig = {
  apiKey: "AIzaSyDiYHzjMqgLIcsYj2_mWhJQo_J9JNBqm9g",
  authDomain: "health-realated.firebaseapp.com",
  projectId: "health-realated",
  storageBucket: "health-realated.appspot.com",
  messagingSenderId: "310576865762",
  appId: "1:310576865762:web:26692b3d92668278f399bb",
};

export default firebaseConfig;
